export const URL = 'https://library-cleverland-2jfze.ondigitalocean.app/api';
export const URL_IMAGE = 'https://library-cleverland-2jfze.ondigitalocean.app';
export const ALL_BOOKS_URL = `${URL}/books`;
export const ALL_CATEGORIES_URL = `${URL}/categories`;

export const URL_AUTH = `${URL}/auth/local`;
export const URL_REGISTRATION = `${URL_AUTH}/register`;
export const URL_FORGOT_PASSWORD = `${URL}/auth/forgot-password`;
export const URL_RESET_PASSWORD = `${URL}/auth/reset-password`;

